import TreeLabel from "./TreeLabel";
import { default as _SearchTree } from "./SearchTree";
var SearchTree = _SearchTree;
SearchTree.TreeLabel = TreeLabel;
export default SearchTree;